<template>
	<div id="ratingsform">
		<div class='hint'>
		  {{this.$store.state.config.data.lnsurance_tip}}
		</div>
		<div class="bm-list">
		  <div class='bm-li' v-on:click="addressPickerShow = true">
			  <div class='left'>选择地区：</div>
			  <div class='right'>
				   <input placeholder="请选择" :value="params.region | pickerValueFilter" readonly/>
			  </div>
		  </div>
		  <div class='bm-li'>
			  <div class='left'>姓名<span style="color:red">*</span>：</div>
			  <div class='right'>
				   <input placeholder="请输入" v-model="params.name"/>
			  </div>
		  </div>
		  <div class='bm-li' v-on:click="sexPicker = true">
			  <div class='left'>性别：</div>
			  <div class='right'>
				   <input placeholder="请输入" :value="params.sex | pickerValueFilter" readonly/>
			  </div>
		  </div>
		  <div class='bm-li'>
			  <div class='left'>身份证号码<span style="color:red">*</span>：</div>
			  <div class='right'>
				   <input placeholder="请输入" v-model="params.idcard"/>
			  </div>
		  </div>
		  <div class='bm-li'>
			  <div class='left'>手机号码<span style="color:red">*</span>：</div>
			  <div class='right'>
				   <input placeholder="请输入" v-model="params.mobile"/>
			  </div>
		  </div>
		  <div class='bm-li'>
			  <div class='left'>教练姓名：</div>
			  <div class='right'>
				   <input placeholder="请输入" v-model="params.jl_name"/>
			  </div>
		  </div>
		  <div class='bm-li'>
			  <div class='left'>教练电话<span style="color:red">*</span>：</div>
			  <div class='right'>
				   <input placeholder="请输入" v-model="params.jl_mobile" type="number"/>
			  </div>
		  </div>
		  <div class='bm-li'>
			  <div class='left'>教练车牌号码：</div>
			  <div class='right'>
				   <input placeholder="请输入" v-model="params.jl_idcard"/>
			  </div>
		  </div>
		</div>
		<div class='baoming-info'>
		  <div class="buy" v-if="updateing != '1'" v-html="this.$store.state.config.data.insurance_explain"></div>
		  <button class='pay' v-on:click="event_submit">去支付</button>
		</div>
		<wv-picker
			      :visible.sync="sexPicker"
			      :columns="sexColumns"
			      v-model="params.sex"
			      value-key="name"
			      @confirm="sexConfirm"
			    />
		<wv-picker
		  :visible.sync="addressPickerShow"
		  v-model="params.region"
		  ref="addressPicker"
		  :columns="addressColumns"
		  :visible-item-count="5"
		  @change="onAddressChange"
		  @confirm="confirmAddress"
		/>
	</div>
</template>

<script>
import chinaAreaData from 'china-area-data'
import { Toast } from 'we-vue'
const provinces = Object.values(chinaAreaData[86])
// 获取某一省下的市
const getCities = (province) => {
  let provinceCode
  for (let i in chinaAreaData[86]) {
    if (province === chinaAreaData[86][i]) {
      provinceCode = i
      break
    }
  }
  return typeof chinaAreaData[provinceCode] === 'object' ? Object.values(chinaAreaData[provinceCode]) : []
}
// 获取某一市下的区/县
function getAreas (province, city) {
  let provinceCode, cityCode
  for (let i in chinaAreaData[86]) {
    if (province === chinaAreaData[86][i]) {
      provinceCode = i
      break
    }
  }
  for (let i in chinaAreaData[provinceCode]) {
    if (city === chinaAreaData[provinceCode][i]) {
      cityCode = i
      break
    }
  }
  if (chinaAreaData[cityCode]) {
    return typeof chinaAreaData[cityCode] === 'object' ? Object.values(chinaAreaData[cityCode]) : []
  } else {
    // 只有两级的情况
    return []
  }
}
export default {
	name: 'Ratingsform',
	data () {
		return {
			insurance_explain:'',
			params:{
				sex:['男'],
				region:['云南省','昆明市'],
				jl_mobile:'',
				mobile:'',
				idcard:'',
				name:''
			},
			tiaokuan:true,
			sexPicker:false,
			sexColumns:[
			  {
			    values: ['男','女']
			  }
			],
			updateing:this.$store.state.config.data.updateing,
			addressPickerShow: false,
			addressColumns: [
				{
					values: provinces
				},
				{
					values: getCities('云南省')
				},
				{
					values: getAreas('云南省', '昆明市')
				}
			]
		}
	},
	mounted () {
		this.params.region = [this.$store.state.userInfo.region0 ? this.$store.state.userInfo.region0 : '云南省', this.$store.state.userInfo.region1 ? this.$store.state.userInfo.region1 : '昆明市',this.$store.state.userInfo.region2 ? this.$store.state.userInfo.region2 : '五华区']
		this.$refs.addressPicker.setValues(this.params.region)
	},
	created (){

	},
	methods:{
		sexConfirm(v){
			console.log(v);
		},
		onAddressChange (picker, addressValues, slotIndex) {
			if (slotIndex === 0) {
				const cities = getCities(addressValues[0])
				picker.setColumnValues(1, cities)
				picker.setColumnValues(2, getAreas(addressValues[0], cities[0]))
			} else if (slotIndex === 1) {
				picker.setColumnValues(2, getAreas(addressValues[0], addressValues[1]))
			}
		},
		confirmAddress (picker) {
			this.address = picker.getValues()
		},
		event_submit(){
			if(!this.params.region[2]){
			      this.$wx.showToast({
				title: '请选择您所在的地区',
				icon:'none'
			      });
			      return false;
			    }

			    if (!this.params.name) {
			      this.$wx.showToast({
				title: '请填写您的姓名',
				icon: 'none'
			      });
			      return false;
			    }

			    if (!this.$app.IdentityCodeValid(this.params.idcard)) {
			      this.$wx.showToast({
				title: '请输入正确的身份证号码',
				icon: 'none'
			      });
			      return false;
			    }

			    if (!/(13|14|15|16|17|18)[0-9]{9}/.test(this.params.mobile)) {
			      this.$wx.showToast({
				title: '请输入正确的手机号码',
				icon: 'none'
			      });
			      return false;
			    }

			    if (!/(13|14|15|16|17|18)[0-9]{9}/.test(this.params.jl_mobile)) {
			      this.$wx.showToast({
				title: '请输入正确的教练手机号码',
				icon: 'none'
			      });
			      return false;
			    }

			    this.params.autoPay = true;
			    this.$store.state.insuranceParams = this.params;
			    this.$wx.navigateBack({
			      delta:1
			    })
		}
	},
	filters:{
		pickerValueFilter (val) {
			if (Array.isArray(val)) {
				return val.toString()
			} else {
				return '请选择'
			}
		}
	}
}
</script>
<style scoped>
	#ratingsform{
		background-color:#efefef;
		min-height:100vh;
	}
	.hint{
	  background: #fcfded;
	  color: #f60;
	  font-size: 4.38vw;
	  padding: 3.5vw 3vw;
	}
	.bm-list{
	  background: #fff;
	  font-size:4.2vw;
	}
	.bm-li{
	  border-bottom:1px solid #dedede;
	  display: flex;
	  justify-content: space-between;
	  height:12vw;
	  line-height:12vw;
	}
	.tiaokuan div{
	  font-size:4.2vw;
	}
	.bm-li .left{
	  padding-left:3vw;
	  min-width:30vw;
	}
	.bm-li .right{
	  padding-right:3vw;
	}
	.bm-li input{
	  text-align: right;
	  height:100%;
	}
	.baoming-info{
	  padding: 3.13vw;
	}
	.tiaokuan{
	  font-size: 4.69vw;
	  display: flex;
	  line-height: 7.5vw;
	}
	.tiaokuan text{
	  color: #59c064;
	}
	.buy{
	  margin-top: 10px;
	  line-height: 7.5vw;
	  color: #666;
	  font-size: 3.69vw;
	}
	.fuwu{
	  color: #59c064;
	}
	.pay{
	  background:#59c064;
	  color: #fff;
	  margin-top: 10px;
	  font-size: 4.69vw;
	  width:100%;
	  border:0px;
	}
	.tiaokuan .icon-circle .circle{
	  width:6vw;
	  margin-right:5px;
	  display:inline-block;
	  border-radius:100%;
	  height:6vw;
	  background-size:100%;
	  border:2px solid #CCCCCC;
	}
	.tiaokuan .rightcircle{
	  background:url(http://jk.ioccn.com/jiakao/rightcircle.png) no-repeat;
	  width:9vw;
	  margin-right:5px;
	  display:inline-block;
	  height:9vw;
	  background-size:100%;
	}
	.tiaokuan .rightcircle .circle{
	  display:none;
	}
	input{
		border:0px;
		display:block;
	}
	button {
		position:relative;
		display:block;
		margin-left:auto;
		margin-right:auto;
		padding-left:14px;
		padding-right:14px;
		box-sizing:border-box;
		font-size:18px;
		text-align:center;
		text-decoration:none;
		line-height:2.55555556;
		border-radius:5px;
		-webkit-tap-highlight-color:transparent;
		overflow:hidden;
		color:#000000;
		background-color:#F8F8F8;
	}
	.pay {
		color:#fff;
		margin-top:10px;
		font-size:4.69vw;
	}
</style>



// WEBPACK FOOTER //
// src/components/Ratingsform.vue